import { sva, RecipeVariantProps } from "styled-system/css";

export const eventOperatorCardRecipe = sva({
  slots: ["surface", "body", "dateAndTitle", "hero"],
  base: {
    surface: {
      display: "grid",
      flexGrow: 1,
      flexShrink: 0,
      backgroundColor: "#FFF",
      borderRadius: "12px",
      gridTemplateAreas: {
        base: "'cardHero' 'cardBody'",
        md: "'cardBody' 'cardHero'",
      },
      gridTemplateColumns: { base: "1fr", md: "auto 180px" },
      gridTemplateRows: { base: "auto auto", md: "180px" },
      minW: { base: "0", md: "360px" },
      maxW: "540px",
      w: "100%",
      h: { base: "auto", md: "180px" },
      maxH: { base: "none", md: "180px" },
      minH: { base: "auto", md: "180px" },
      overflow: "hidden",
    },
    body: {
      p: { base: "200", md: "24px" },
      justifyContent: "space-between",
      rowGap: "0",
      w: "full",
      gridArea: "cardBody",
    },
    dateAndTitle: {
      flexDir: "column",
      gap: "100",
    },
    hero: {
      display: "flex",
      alignItems: "center",
      justifyContent: { base: "center", md: "flex-start" },
      w: { base: "full", md: "180px" },
      maxW: { base: "full", md: "180px" },
      minW: { base: "0", md: "180px" },
      h: { base: "160px", md: "180px" },
      maxH: { base: "160px", md: "180px" },
      minH: { base: "160px", md: "180px" },
      overflow: "hidden",
    },
  },
  variants: {
    borderStyle: {
      solid: {
        surface: {
          bgColor: "white",
        },
      },
      dashed: {
        surface: {
          borderStyle: "dashed",
          bgColor: "bg.wa.lightest",
        },
      },
    },
  },
  defaultVariants: {
    borderStyle: "solid",
  },
});

export type EventOperatorCardRecipeProps = RecipeVariantProps<
  typeof eventOperatorCardRecipe
>;
